<template>
    <!-- 运动员等级评定 详情/审核 -->
    <div class="view">
        <router-link to="/account/vipApplyLists" class="backBtn"> &lt; 返回</router-link>
        <span v-show="pageTit" v-text="'当前：' + pageTit"></span>
        <div class="infosBox">
            <div class="basicInfo">
                <div class="group">
                    <label>机构名称：</label>
                    <span v-text="company_name || '-'"></span>
                </div>
                <div class="group">
                    <label>机构全称：</label>
                    <span v-text="company_full_name || '-'"></span>
                </div>
                <div class="group">
                    <label>机构类型：</label>
                    <span v-text="company_type_name"></span>
                </div>
                <div class="group">
                    <label>统一社会信用代码：</label>
                    <span v-text="credit_code"></span>
                </div>
                <div class="group">
                    <label>所属行业：</label>
                    <span v-text="subordinate_industry_name"></span>
                </div>
                <div class="group">
                    <label>所在地区：</label>
                    <span v-text="address"></span>
                </div>
                <div class="group">
                    <label>上级单位：</label>
                    <span v-text="up_member_no_name"></span>
                </div>
                <div class="group">
                    <label>单位LOGO：</label>
                    <div class="uploadPic clearfix">
                        <div class="pic fl">
                            <img class="img-change" :src="picImg1" alt="">
                        </div>
                    </div>
                </div>
                <div class="group">
                    <label>营业执照：</label>
                    <div class="uploadPic clearfix">
                        <div class="pic fl">
                            <img class="img-change" :src="picImg2">
                        </div>
                    </div>
                </div>
                <div class="group">
                    <label>审核结果：</label>
                    <div class="radioBox">
                        <input type="radio" name="result" id="result1" v-model="apply_result" value="1" :disabled="confirm_status != 0"><label for="result1">通过</label>
                        <input type="radio" name="result" id="result2" v-model="apply_result" value="2" :disabled="confirm_status != 0"><label for="result2">不通过</label>
                    </div>
                </div>
                <div>

                </div>
                <div class="group">
                    <label>备注：</label>
                    <textarea class="remark" v-model.trim="memo" cols="60" rows="10" maxlength="300" :disabled="confirm_status != 0"></textarea>
                </div>
            </div>
            <br>
            <br>
        </div>
        <div class="handleBox" v-if="confirm_status == 0">
            <button @click="submitHandle()" v-text="btn_txt"></button>
        </div>
        <TipHandle
            :txt="tip"
            :btnTxt="btnTxt"
            @maskHandle="maskHandle($event)"
            />
    </div>
</template>

<script>
import TipHandle from '@/components/TipHandle.vue'
import { toQueryString } from '@/assets/js/util'

export default {
    name: 'ApplyDetail',
    components: {
        TipHandle
    },
    props: {},
    data() {
        return {
            token: this.$cookies.get('token'),
            tip: '',
            btnTxt: [],
            pageTit: '',
            company_name: '',
            company_full_name:'',
            company_type_name: '',
            credit_code: '',
            subordinate_industry_name: '',
            address: '',
            up_member_no_name: '',
            eventList: [],
            picImg1:require("@/assets/imgs/joinImg2.png"),
            picImg1Data:'',
            picImg2:require("@/assets/imgs/joinImg2.png"),
            picImg2Data:'',
            apply_result: 0,
            confirm_status: '',
            memo: '',
            btn_txt: '提交',
            listLoadTip: '',
            submitFlag:true,
        }
    },
    mounted(){
        this.urlId = this.$route.params.id
        if(this.urlId > 0){
            this.getDetail()
        }
    },
    methods: {
        handleTips(txt, btnTxt){
            this.tip = txt
            this.btnTxt = btnTxt
        },
        maskHandle(btn){
            if(btn == 0) {
                this.changeStatus()
            } else if(btn == 1){
                // 提交成功，返回列表
                this.$router.push('/account/vipApplyLists')
            }
            this.tip = ''
        },
        //获取详情
        getDetail () {
            this.listLoadTip = '数据加载中...'
            this.$axios.post('CESA/CentEntrance', toQueryString({
                action: 'Get_Manage_company',
                user_token: this.token,
                company_member_no: this.urlId,
                company_name: '',
                confirm_status: '',
                page: 0,
                count: 0
            })).then((res) => {
                let data = res.data
                if(data.code == -200) {
                    this.handleTips('登录失效，请刷新重新登录', ['刷新'])
                    return
                }
                if(data.code == 1) {
                    let obj = data.data
                    this.company_name = obj.company_name
                    this.company_full_name = obj.company_full_name
                    this.company_type_name = obj.company_type_name
                    this.address = (obj.province_name == obj.city_name ? '' : obj.province_name) + obj.city_name + obj.area_name
                    this.credit_code = obj.credit_code
                    this.subordinate_industry_name = obj.subordinate_industry_name
                    this.up_member_no_name = obj.up_member_no_name
                    this.eventList = obj.eventList
                    this.accessory = obj.accessory
                    if(obj.headimgurl) {
                        this.picImg1 = data.Url + '/' + obj.headimgurl
                    }
                    if(obj.business_license) {
                        this.picImg2 = data.Url + '/' + obj.business_license
                    }
                    this.memo = obj.memo
                    this.apply_result = obj.confirm_status
                    this.confirm_status = obj.confirm_status
                    if(this.confirm_status == 0) {
                        this.pageTit = '机构会员审核'
                    } else {
                        this.pageTit = '查看机构会员详情'
                    }
                } else {
                    this.handleTips(data.message, ['关闭'])
                }
            }).catch(() => {
                this.handleTips('网络异常', ['关闭'])
            });
        },
        // 提交审核
        submitHandle() {
            if(!this.submitFlag) {
                return
            }
            if(this.apply_result == 0) {
                this.handleTips('请选择审核结果', ['关闭'])
                return
            } else if(this.apply_result == 1) {
                this.handleTips('确认通过审核？', ['确认', '关闭'])
            } else if(this.apply_result == 2) {
                if(!this.memo) {
                    this.handleTips('请填写备注', ['关闭'])
                    return
                }
                this.handleTips('确认不通过审核？', ['确认', '关闭'])
            }
        },
        // 确认通过(1) or 不通过(2)
        changeStatus() {
            if(this.submitFlag) {
                this.submitFlag = false
            } else {
                return
            }
            this.btn_txt = '提交中...'

            this.$axios.post('CESA/Entrance', toQueryString({
                action: 'Upt_Manage_company',
                user_token: this.token,
                company_member_no: this.urlId,
                confirm_status: this.apply_result,
                company_name: this.company_name,
                memo: this.memo
            })).then((res) => {
                let data = res.data
                this.btn_txt = '提交'
                if(data.code == -200) {
                    this.handleTips('登录失效，请刷新重新登录', ['刷新'])
                } else if(data.code == 1) {
                    this.handleTips('提交成功', ['', '返回列表'])
                } else {
                    this.submitFlag = true
                    this.handleTips(data.message, ['关闭'])
                }
            }).catch(() => {
                this.btn_txt = '提交'
                this.submitFlag = true
                this.handleTips('网络异常', ['关闭'])
            })
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .infosBox label{
        width: 9rem;
    }
    .group .radioBox{
        display: inline-block;
    }
    .group .radioBox label{
        width: 5rem;
        margin-right: 1.5rem;
        text-align: left;
        cursor: pointer;
    }
    .applyList{
        border: 1px solid #ccc;
        border-radius: .6rem;
        padding: .4rem 1rem;
        box-sizing: border-box;
        margin: 1rem;
    }
    .infosBox .group{
        line-height: 2.2rem;
    }
    .uploadPic .pic{
        width: 7rem;
        height: 7rem;
    }
    .uploadPic .pic img{
        width: 100%;
        height: 100%;
    }
    input[type="radio"]{vertical-align:middle;display:none;}
    input[type='radio']+label:before{
        content:'';display:inline-block;width:1.2rem;height:1.2rem;margin:-2px 5px 0 0;border-radius:100%;vertical-align:middle;border:1px solid #956435;}
    input[type='radio']:checked+label:before{background:#F57F00 url('~@/assets/imgs/yes.png') no-repeat center center;background-size:80%;}
</style>
